import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { navLinks, profile } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const isHome = location.pathname === "/";
  const solid = scrolled || !isHome || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        solid
          ? "bg-[#faf8f4]/95 backdrop-blur-md shadow-[0_1px_0_rgba(0,0,0,0.06)] py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between">
        <Link to="/" className="group flex flex-col leading-none">
          <span
            className={`font-serif text-xl md:text-2xl font-bold tracking-tight transition-colors duration-300 ${
              solid ? "text-[#1a2b4a]" : "text-white"
            }`}
          >
            T.P. Sreenivasan
          </span>
          <span
            className={`text-[10px] md:text-[11px] uppercase tracking-[0.28em] mt-1 transition-colors duration-300 ${
              solid ? "text-[#b8935a]" : "text-[#e6c98d]"
            }`}
          >
            Diplomat · Author
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => {
            const active = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`relative px-4 py-2 text-sm font-medium tracking-wide transition-colors duration-300 ${
                  solid
                    ? active
                      ? "text-[#b8935a]"
                      : "text-[#3a4155] hover:text-[#1a2b4a]"
                    : active
                    ? "text-[#e6c98d]"
                    : "text-white/85 hover:text-white"
                }`}
              >
                {link.label}
                <span
                  className={`absolute left-4 right-4 -bottom-0.5 h-[2px] bg-[#b8935a] transition-transform duration-300 origin-left ${
                    active ? "scale-x-100" : "scale-x-0"
                  }`}
                />
              </Link>
            );
          })}
        </nav>

        {/* Mobile toggle */}
        <button
          onClick={() => setOpen((o) => !o)}
          className={`lg:hidden p-2 rounded-md transition-colors ${
            solid ? "text-[#1a2b4a]" : "text-white"
          }`}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ${
          open ? "max-h-[520px] mt-3" : "max-h-0"
        }`}
      >
        <nav className="px-5 pb-5 flex flex-col gap-1 bg-[#faf8f4]">
          {navLinks.map((link) => {
            const active = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 rounded-md text-base font-medium border-l-2 transition-colors ${
                  active
                    ? "text-[#b8935a] border-[#b8935a] bg-[#b8935a]/5"
                    : "text-[#3a4155] border-transparent hover:bg-black/[0.03]"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
}
